if (!Promise.all) {
  Promise.all = function (promises) {
    return new Promise((resolve, reject) => {
      const results = [];
      let remaining = promises.length;

      if (remaining === 0) resolve([]);

      promises.forEach((p, i) => {
        Promise.resolve(p).then((val) => {
          results[i] = val;
          if (--remaining === 0) resolve(results);
        });
        // .catch(reject);
      });
    });
  };
}
